export default __webpack_public_path__ + "static/media/profile0.b16799f3.svg";